<div class="container-fluid glb-popup">
  <h2>{{ formTitle }}</h2>
  <p-toast [style]="{ marginTop: '80px' }"> </p-toast>
  <p-confirmDialog
    header="Confirmation"
    icon="pi pi-exclamation-triangle"
  ></p-confirmDialog>

  <button
    mat-icon-button
    [mat-dialog-close]="true"
    style="float: right; top: -50px; background-color: transparent"
    >
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr />
  <app-create-user (userInfo)="userInfo($event)"></app-create-user>
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">
      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
            <div
              class="w-100"
            style="
              text-align: center;
              background-color: yellow;
              padding: 5px;
              margin-bottom: 15px;
            "
              >
              <p>
                <b>{{ formAlert }}</b>
              </p>
            </div>
          </div>
        }
      </div>

      @if (!employeeProfileId) {
        <div class="col-lg-12">
          <label for="userId">Select User( if user is not in list create new by  above + button)</label>
          <span class="p-float-label required-field w-100 mb-3">
            <p-autoComplete class="col-lg-12" [suggestions]="users" [multiple]="false" [forceSelection]="false" [dropdown]="false" [style]="{'width':'100%'}"
              [inputStyle]="{'width':'100%'}" [minLength]="2" unique="true" field="fullName" placeholder="Select User" (completeMethod)="onKeyInput($event)"
            formControlName="userId" (onSelect)="onUserSeleted($event)"> </p-autoComplete>
            @for (validation of validationMessages.userId; track validation) {
              <span>
                @if (form1.get('userId').hasError(validation.type) && (form1.get('userId').dirty || form1.get('userId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      }



      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="listingStatuses" formControlName="listingStatus" optionLabel="name"
            optionValue="value" [filter]="true" filterBy="value" [showClear]="false"
          placeholder="Select Status"></p-dropdown>
          <label for="Select Status">Select Status</label>
          @for (validation of validationMessages.listingStatus; track validation) {
            <span>
              @if (form1.get('listingStatus').hasError(validation.type) && (form1.get('listingStatus').dirty || form1.get('listingStatus').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="jobCategories" formControlName="jobCategory" optionLabel="name"
            optionValue="value" [filter]="true" filterBy="value" [showClear]="false"
          placeholder="Job Categories"></p-dropdown>
          <label for="Job Categories">Job Categories</label>
          @for (validation of validationMessages.jobCategory; track validation) {
            <span>
              @if (form1.get('jobCategory').hasError(validation.type) && (form1.get('jobCategory').dirty || form1.get('jobCategory').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="jobLevels" formControlName="jobLevel" optionLabel="name"
            optionValue="value" [filter]="true" filterBy="value" [showClear]="false"
          placeholder="Job Levels"></p-dropdown>
          <label for="Job Levels">Job Levels</label>
          @for (validation of validationMessages.jobLevel; track validation) {
            <span>
              @if (form1.get('jobLevel').hasError(validation.type) && (form1.get('jobLevel').dirty || form1.get('jobLevel').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="locations" formControlName="locationId" optionLabel="name"
            optionValue="locationId" [filter]="true" filterBy="name" [showClear]="false"
          placeholder="Select Locations"></p-dropdown>
          <label for="Select Locations">Select Locations</label>
          @for (validation of validationMessages.locationId; track validation) {
            <span>
              @if (form1.get('locationId').hasError(validation.type) && (form1.get('locationId').dirty || form1.get('locationId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2">
        <span class="p-float-label required-field w-100 mb-3"
          >
          <p-dropdown
            class="w-100"
            [options]="titles"
            formControlName="title"
            optionLabel="name"
            optionValue="value"
            placeholder="Titles"
          ></p-dropdown>
          <label for="title">Title</label
            >@for (validation of validationMessages.title; track validation) {
            <span
              >@if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
              }</span
              >
              }</span
              >
            </div>

            <div class="col-lg-4">
              <span class="p-float-label required-field w-100 mb-3">
                <input formControlName="firstName" id="firstName" type="text" pInputText/>
                <label for="firstName">First Name</label>
                @for (validation of validationMessages.firstName; track validation) {
                  <span>
                    @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }</span>
                  }
                </span>
              </div>
              <div class="col-lg-4">
                <span class="p-float-label required-field w-100 mb-3">
                  <input formControlName="lastName" id="lastName" type="text" pInputText/>
                  <label for="lastName">Last Name</label>
                  @for (validation of validationMessages.lastName; track validation) {
                    <span>
                      @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }</span>
                    }
                  </span>
                </div>

                <div class="col-lg-2">
                  <span class="p-float-label required-field w-100 mb-3"
                    ><input
                    formControlName="suffix"
                    id="suffix"
                    type="text"
                    pInputText
                    /><label for="suffix">Suffix</label
                    >@for (validation of validationMessages.suffix; track validation) {
                    <span
                      >@if (form1.get('suffix').hasError(validation.type) && (form1.get('suffix').dirty || form1.get('suffix').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                      }</span
                      >
                      }</span
                      >
                    </div>

                    <div class="col-lg-6">
                      <span class="p-float-label required-field w-100 mb-3">
                        <input formControlName="emailAddress" id="emailAddress" type="text" pInputText/>
                        <label for="emailAddress">Email</label>
                        @for (validation of validationMessages.emailAddress; track validation) {
                          <span>
                            @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }</span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-6">
                        <span class="p-float-label required-field w-100 mb-3"
                          ><input
                          formControlName="perEmailAddress"
                          id="perEmailAddress"
                          type="text"
                          pInputText
                          /><label for="perEmailAddress">Personal Email</label
                          >@for (validation of validationMessages.perEmailAddress; track validation) {
                          <span
                            >@if (form1.get('perEmailAddress').hasError(validation.type) && (form1.get('perEmailAddress').dirty || form1.get('perEmailAddress').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                            }</span
                            >
                            }</span
                            >
                          </div>
                          <div class="col-lg-6">
                            <span class="p-float-label required-field w-100 mb-3">
                              <!-- <p-inputMask formControlName="mobilePhone" id="mobilePhone" mask="(999) 999-9999" type="text">
                            </p-inputMask> -->
                            <input formControlName="mobilePhone" id="mobilePhone" type="text" pInputText>
                            <label for="mobilePhone">Mobile Phone</label>
                            @for (validation of validationMessages.mobilePhone; track validation) {
                              <span>
                                @if (form1.get('mobilePhone').hasError(validation.type) && (form1.get('mobilePhone').dirty || form1.get('mobilePhone').touched)) {
                                  <small class="p-invalid"
                                    >{{validation.message}}
                                  </small>
                                }
                              </span>
                            }
                          </span>
                        </div>
                        <div class="col-lg-6">
                          <span class="p-float-label required-field w-100 mb-3">
                            <!-- <p-inputMask formControlName="perMobilePhone" id="perMobilePhone" mask="(999) 999-9999" type="text">
                          </p-inputMask> -->
                          <input formControlName="perMobilePhone" id="perMobilePhone" type="text" pInputText>
                          <label for="perMobilePhone">Personal Mobile Phone</label>
                          @for (validation of validationMessages.perMobilePhone; track validation) {
                            <span>
                              @if (form1.get('perMobilePhone').hasError(validation.type) && (form1.get('perMobilePhone').dirty || form1.get('perMobilePhone').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-6">
                        <span class="p-float-label w-100 mb-3">
                          <p-dropdown
                            class="w-100"
                            [options]="taxStatuses"
                            formControlName="taxStatus"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="taxStatus"
                          ></p-dropdown>
                          <label for="taxStatus">Tax Status</label>
                          @for (validation of validationMessages.taxStatus; track validation) {
                            <span>
                              @if (form1.get('taxStatus').hasError(validation.type) && (form1.get('taxStatus').dirty || form1.get('taxStatus').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-6">
                        <span class="p-float-label w-100 mb-3">
                          <p-dropdown
                            class="w-100"
                            [options]="taxExemptElects"
                            formControlName="taxExemptElect"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="taxExemptElect"
                          ></p-dropdown>
                          <label for="taxExemptElect">Tax Exempt Elect</label>
                          @for (validation of validationMessages.taxExemptElect; track validation) {
                            <span>
                              @if (form1.get('taxExemptElect').hasError(validation.type) && (form1.get('taxExemptElect').dirty || form1.get('taxExemptElect').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-6">
                        <span class="p-float-label w-100 mb-3">
                          <p-calendar
                            formControlName="hireDate"
                            inputId="hireDate"
                            appendTo="body"
                            >
                          </p-calendar>
                          <label for="hireDate">Hire Date</label>
                          @for (validation of validationMessages.hireDate; track validation) {
                            <span>
                              @if (form1.get('hireDate').hasError(validation.type) && (form1.get('hireDate').dirty || form1.get('hireDate').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-6">
                        <span class="p-float-label w-100 mb-3">
                          <p-calendar
                            formControlName="startDate"
                            inputId="startDate"
                            appendTo="body"
                            >
                          </p-calendar>
                          <label for="startDate">Start Date</label>
                          @for (validation of validationMessages.startDate; track validation) {
                            <span>
                              @if (form1.get('startDate').hasError(validation.type) && (form1.get('startDate').dirty || form1.get('startDate').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-4">
                        <span class="p-float-label w-100 mb-3">
                          <p-calendar
                            formControlName="termDate"
                            inputId="termDate"
                            appendTo="body"
                            >
                          </p-calendar>
                          <label for="termDate">Term Date</label>
                          @for (validation of validationMessages.termDate; track validation) {
                            <span>
                              @if (form1.get('termDate').hasError(validation.type) && (form1.get('termDate').dirty || form1.get('termDate').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-4">
                        <span class="p-float-label w-100 mb-3">
                          <p-dropdown
                            class="w-100"
                            [options]="termReasons"
                            formControlName="termReason"
                            optionLabel="name"
                            optionValue="value"
                            placeholder="termReason"
                          ></p-dropdown>
                          <label for="termReason">Term Reason</label>
                          @for (validation of validationMessages.termReason; track validation) {
                            <span>
                              @if (form1.get('termReason').hasError(validation.type) && (form1.get('termReason').dirty || form1.get('termReason').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-4">
                        <div class="flex align-items-center">
                          <p-checkbox
                            [formControl]="form1.controls['eligForRehire']"
                            inputId="eligForRehire"
                            [binary]="true"
                          ></p-checkbox>
                          <span class="employeeProfile-nm">Eligible For Rehire</span>
                        </div>
                        @for (validation of validationMessages.eligForRehire; track validation) {
                          <span>
                            @if (form1.get('eligForRehire').hasError(validation.type) && (form1.get('eligForRehire').dirty || form1.get('eligForRehire').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </div>
                      <div class="col-lg-6">
                        <span class="p-float-label required-field w-100 mb-3"
                          ><input
                          formControlName="positionName"
                          id="positionName"
                          type="text"
                          pInputText
                          /><label for="positionName">Position Name</label
                          >@for (validation of validationMessages.positionName; track validation) {
                          <span
                            >@if (form1.get('positionName').hasError(validation.type) && (form1.get('positionName').dirty || form1.get('positionName').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                            }</span
                            >
                            }</span
                            >
                          </div>
                          <div class="col-lg-6">
                            <span class="p-float-label required-field w-100 mb-3"
                              ><input
                              formControlName="payRate"
                              id="payRate"
                              type="text"
                              pInputText
                              /><label for="payRate">Pay Rate</label
                              >@for (validation of validationMessages.payRate; track validation) {
                              <span
                                >@if (form1.get('payRate').hasError(validation.type) && (form1.get('payRate').dirty || form1.get('payRate').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                                }</span
                                >
                                }</span
                                >
                              </div>
                              <div class="col-lg-6">
                                <span class="p-float-label w-100 mb-3">
                                  <p-dropdown
                                    class="w-100"
                                    [options]="payRateFreqs"
                                    formControlName="payRateFreq"
                                    optionLabel="name"
                                    optionValue="value"
                                    placeholder="payRateFreq"
                                  ></p-dropdown>
                                  <label for="payRateFreq">Pay Rate Frequency</label>
                                  @for (validation of validationMessages.payRateFreq; track validation) {
                                    <span>
                                      @if (form1.get('payRateFreq').hasError(validation.type) && (form1.get('payRateFreq').dirty || form1.get('payRateFreq').touched)) {
                                        <small class="p-invalid"
                                          >{{validation.message}}
                                        </small>
                                      }
                                    </span>
                                  }
                                </span>
                              </div>
                              <div class="col-lg-6">
                                <span class="p-float-label w-100 mb-3">
                                  <p-dropdown
                                    class="w-100"
                                    [options]="contractOrPerms"
                                    formControlName="contractOrPerm"
                                    optionLabel="name"
                                    optionValue="value"
                                    placeholder="contractOrPerm"
                                  ></p-dropdown>
                                  <label for="contractOrPerm">Contract Or Permanent</label>
                                  @for (validation of validationMessages.contractOrPerm; track validation) {
                                    <span>
                                      @if (form1.get('contractOrPerm').hasError(validation.type) && (form1.get('contractOrPerm').dirty || form1.get('contractOrPerm').touched)) {
                                        <small class="p-invalid"
                                          >{{validation.message}}
                                        </small>
                                      }
                                    </span>
                                  }
                                </span>
                              </div>
                              <div class="col-lg-6">
                                <span class="p-float-label w-100 mb-3">
                                  <p-dropdown
                                    class="w-100"
                                    [options]="salaryOrHourlys"
                                    formControlName="salaryOrHourly"
                                    optionLabel="name"
                                    optionValue="value"
                                    placeholder="salaryOrHourly"
                                  ></p-dropdown>
                                  <label for="salaryOrHourly">Salary Or Hourly</label>
                                  @for (validation of validationMessages.salaryOrHourly; track validation) {
                                    <span>
                                      @if (form1.get('salaryOrHourly').hasError(validation.type) && (form1.get('salaryOrHourly').dirty || form1.get('salaryOrHourly').touched)) {
                                        <small class="p-invalid"
                                          >{{validation.message}}
                                        </small>
                                      }
                                    </span>
                                  }
                                </span>
                              </div>
                              <div class="col-lg-6">
                                <span class="p-float-label w-100 mb-3">
                                  <p-dropdown class="w-100" [options]="statuses" formControlName="adrType" optionLabel="name"
                                  optionValue="value" placeholder="Select Address Type"></p-dropdown>
                                  <label for="Select Address Type">Select Address Type</label>
                                  @for (validation of validationMessages.adrType; track validation) {
                                    <span>
                                      @if (form1.get('adrType').hasError(validation.type) && (form1.get('adrType').dirty || form1.get('adrType').touched)) {
                                        <small class="p-invalid"
                                          >{{validation.message}}
                                        </small>
                                      }
                                    </span>
                                  }
                                </span>
                              </div>
                              <div class="col-lg-12">
                                <span class="p-float-label required-field w-100 mb-3"
                                  ><input
                                  formControlName="adrStreet"
                                  id="adrStreet"
                                  type="text"
                                  pInputText
                                  /><label for="adrStreet">Street</label
                                  >@for (validation of validationMessages.adrStreet; track validation) {
                                  <span
                                    >@if (form1.get('adrStreet').hasError(validation.type) && (form1.get('adrStreet').dirty || form1.get('adrStreet').touched)) {
                                    <small class="p-invalid"
                                      >{{validation.message}}
                                    </small>
                                    }</span
                                    >
                                    }</span
                                    >
                                  </div>
                                  <div class="col-lg-12">
                                    <span class="p-float-label required-field w-100 mb-3"
                                      ><input
                                      formControlName="adrStreet2"
                                      id="adrStreet2"
                                      type="text"
                                      pInputText
                                      /><label for="adrStreet2">Street 2</label
                                      >@for (validation of validationMessages.adrStreet2; track validation) {
                                      <span
                                        >@if (form1.get('adrStreet2').hasError(validation.type) && (form1.get('adrStreet2').dirty || form1.get('adrStreet2').touched)) {
                                        <small class="p-invalid"
                                          >{{validation.message}}
                                        </small>
                                        }</span
                                        >
                                        }</span
                                        >
                                      </div>
                                      <div class="col-lg-5">
                                        <span class="p-float-label required-field w-100 mb-3">
                                          <input formControlName="adrCity" id="adrCity" type="text" pInputText>
                                          <label for="adrCity">Adr City</label>
                                          @for (validation of validationMessages.adrCity; track validation) {
                                            <span>
                                              @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty || form1.get('adrCity').touched)) {
                                                <small class="p-invalid"
                                                  >{{validation.message}}
                                                </small>
                                              }
                                            </span>
                                          }
                                        </span>
                                      </div>

                                      <div class="col-lg-2">
                                        <span class="p-float-label required-field w-100 mb-3">
                                          <p-dropdown [options]="states" formControlName="adrState" optionLabel="name" appendTo="body"
                                            optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
                                            placeholder="State">
                                          </p-dropdown>
                                          <label for="adrState">Adr State</label>
                                          @for (validation of validationMessages.adrState; track validation) {
                                            <span>
                                              @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty || form1.get('adrState').touched)) {
                                                <small class="p-invalid"
                                                  >{{validation.message}}
                                                </small>
                                              }
                                            </span>
                                          }
                                        </span>
                                      </div>

                                      <div class="col-lg-2">
                                        <span class="p-float-label required-field w-100 mb-3">
                                          <input formControlName="adrPostalCode" id="adrPostalCode" type="text" pInputText>
                                          <label for="adrPostalCode">Adr Postal Code</label>
                                          @for (validation of validationMessages.adrPostalCode; track validation) {
                                            <span>
                                              @if (form1.get('adrPostalCode').hasError(validation.type) && (form1.get('adrPostalCode').dirty || form1.get('adrPostalCode').touched)) {
                                                <small class="p-invalid"
                                                  >{{validation.message}}
                                                </small>
                                              }
                                            </span>
                                          }
                                        </span>
                                      </div>

                                      <div class="col-lg-3">
                                        <span class="p-float-label required-field w-100 mb-3">
                                          <p-dropdown [options]="countries" formControlName="adrCountry" optionLabel="name" appendTo="body"
                                            optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
                                            placeholder="Country">
                                          </p-dropdown>
                                          <label for="adrCountry">Adr Country</label>
                                          @for (validation of validationMessages.adrCountry; track validation) {
                                            <span>
                                              @if (form1.get('adrCountry').hasError(validation.type) && (form1.get('adrCountry').dirty || form1.get('adrCountry').touched)) {
                                                <small class="p-invalid"
                                                  >{{validation.message}}
                                                </small>
                                              }
                                            </span>
                                          }
                                        </span>
                                      </div>
                                      <div class="col-lg-6">
                                        <span class="p-float-label required-field w-100 mb-3">
                                          <!-- <p-inputMask formControlName="adrPhone" id="adrPhone" mask="(999) 999-9999" type="text">
                                        </p-inputMask> -->
                                        <input formControlName="adrPhone" id="adrPhone" type="text" pInputText>
                                        <label for="adrPhone">Phone</label
                                          >@for (validation of validationMessages.adrPhone; track validation) {
                                          <span
                                            >@if (form1.get('adrPhone').hasError(validation.type) && (form1.get('adrPhone').dirty || form1.get('adrPhone').touched)) {
                                            <small class="p-invalid"
                                              >{{validation.message}}
                                            </small>
                                            }</span
                                            >
                                            }</span
                                            >
                                          </div>
                                          <div class="col-lg-6">
                                            <span class="p-float-label required-field w-100 mb-3"
                                              ><input
                                              formControlName="adrFax"
                                              id="adrFax"
                                              type="text"
                                              pInputText
                                              /><label for="adrFax">Fax</label
                                              >@for (validation of validationMessages.adrFax; track validation) {
                                              <span
                                                >@if (form1.get('adrFax').hasError(validation.type) && (form1.get('adrFax').dirty || form1.get('adrFax').touched)) {
                                                <small class="p-invalid"
                                                  >{{validation.message}}
                                                </small>
                                                }</span
                                                >
                                                }</span
                                                >
                                              </div>
                                              <div class="col-lg-12">
                                                <span class="p-float-label required-field w-100 mb-3">
                                                  <textarea
                                                    formControlName="familyDesc"
                                                    id="familyDesc"
                                                    [rows]="2"
                                                    pInputTextarea
                                                    ></textarea
                                                    ><label for="familyDesc">Family Description</label
                                                    >@for (validation of validationMessages.familyDesc; track validation) {
                                                    <span
                                                      >@if (form1.get('familyDesc').hasError(validation.type) && (form1.get('familyDesc').dirty || form1.get('familyDesc').touched)) {
                                                      <small class="p-invalid"
                                                        >{{validation.message}}
                                                      </small>
                                                      }</span
                                                      >
                                                      }</span
                                                      >
                                                    </div>
                                                    <div class="col-lg-12">
                                                      <span class="p-float-label required-field w-100 mb-3">
                                                        <textarea
                                                          formControlName="favSportsDesc"
                                                          id="favSportsDesc"
                                                          [rows]="2"
                                                          pInputTextarea
                                                          ></textarea
                                                          ><label for="favSportsDesc">Favorite Sports Description</label
                                                          >@for (validation of validationMessages.favSportsDesc; track validation) {
                                                          <span
                                                            >@if (form1.get('favSportsDesc').hasError(validation.type) && (form1.get('favSportsDesc').dirty || form1.get('favSportsDesc').touched)) {
                                                            <small class="p-invalid"
                                                              >{{validation.message}}
                                                            </small>
                                                            }</span
                                                            >
                                                            }</span
                                                            >
                                                          </div>
                                                          <div class="col-lg-12">
                                                            <span class="p-float-label required-field w-100 mb-3">
                                                              <textarea
                                                                formControlName="educationDesc"
                                                                id="educationDesc"
                                                                [rows]="2"
                                                                pInputTextarea
                                                                ></textarea
                                                                ><label for="educationDesc">Education Description</label
                                                                >@for (validation of validationMessages.educationDesc; track validation) {
                                                                <span
                                                                  >@if (form1.get('educationDesc').hasError(validation.type) && (form1.get('educationDesc').dirty || form1.get('educationDesc').touched)) {
                                                                  <small class="p-invalid"
                                                                    >{{validation.message}}
                                                                  </small>
                                                                  }</span
                                                                  >
                                                                  }</span
                                                                  >
                                                                </div>
                                                                <div class="col-lg-12">
                                                                  <span class="p-float-label required-field w-100 mb-3">
                                                                    <textarea
                                                                      formControlName="politicsDesc"
                                                                      id="politicsDesc"
                                                                      [rows]="2"
                                                                      pInputTextarea
                                                                      ></textarea
                                                                      ><label for="politicsDesc">Political Description</label
                                                                      >@for (validation of validationMessages.politicsDesc; track validation) {
                                                                      <span
                                                                        >@if (form1.get('politicsDesc').hasError(validation.type) && (form1.get('politicsDesc').dirty || form1.get('politicsDesc').touched)) {
                                                                        <small class="p-invalid"
                                                                          >{{validation.message}}
                                                                        </small>
                                                                        }</span
                                                                        >
                                                                        }</span
                                                                        >
                                                                      </div>
                                                                      <div class="col-lg-12">
                                                                        <span class="p-float-label required-field w-100 mb-3">
                                                                          <textarea
                                                                            formControlName="opsNotes"
                                                                            id="opsNotes"
                                                                            [rows]="2"
                                                                            pInputTextarea
                                                                            ></textarea
                                                                            ><label for="opsNotes">Operational Notes</label
                                                                            >@for (validation of validationMessages.opsNotes; track validation) {
                                                                            <span
                                                                              >@if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                                                                              <small class="p-invalid"
                                                                                >{{validation.message}}
                                                                              </small>
                                                                              }</span
                                                                              >
                                                                              }</span
                                                                              >
                                                                            </div>
                                                                            <div class="col-lg-6">
                                                                              <span class="p-float-label w-100 mb-3">
                                                                                <p-calendar
                                                                                  formControlName="anniversary"
                                                                                  inputId="anniversary"
                                                                                  appendTo="body"
                                                                                  >
                                                                                </p-calendar>
                                                                                <label for="anniversary">Anniversary</label>
                                                                                @for (validation of validationMessages.anniversary; track validation) {
                                                                                  <span>
                                                                                    @if (form1.get('anniversary').hasError(validation.type) && (form1.get('anniversary').dirty || form1.get('anniversary').touched)) {
                                                                                      <small class="p-invalid"
                                                                                        >{{validation.message}}
                                                                                      </small>
                                                                                    }
                                                                                  </span>
                                                                                }
                                                                              </span>
                                                                            </div>
                                                                            <div class="col-lg-6">
                                                                              <span class="p-float-label w-100 mb-3">
                                                                                <p-calendar
                                                                                  formControlName="birthday"
                                                                                  inputId="birthday"
                                                                                  appendTo="body"
                                                                                  >
                                                                                </p-calendar>
                                                                                <label for="birthday">Birthday</label>
                                                                                @for (validation of validationMessages.birthday; track validation) {
                                                                                  <span>
                                                                                    @if (form1.get('birthday').hasError(validation.type) && (form1.get('birthday').dirty || form1.get('birthday').touched)) {
                                                                                      <small class="p-invalid"
                                                                                        >{{validation.message}}
                                                                                      </small>
                                                                                    }
                                                                                  </span>
                                                                                }
                                                                              </span>
                                                                            </div>
                                                                            <div class="col-lg-6">
                                                                              <span class="p-float-label w-100 mb-3">
                                                                                <p-dropdown class="w-100" [options]="genders" formControlName="gender" optionLabel="name"
                                                                                optionValue="value" placeholder="Gender"></p-dropdown>
                                                                                <label for="gender">Gender</label>
                                                                                @for (validation of validationMessages.gender; track validation) {
                                                                                  <span>
                                                                                    @if (form1.get('gender').hasError(validation.type) && (form1.get('gender').dirty || form1.get('gender').touched)) {
                                                                                      <small class="p-invalid"
                                                                                        >{{validation.message}}
                                                                                      </small>
                                                                                    }
                                                                                  </span>
                                                                                }
                                                                              </span>
                                                                            </div>
                                                                            <div class="col-lg-6">
                                                                              <span class="p-float-label required-field w-100 mb-3"
                                                                                ><input
                                                                                formControlName="socSecNum"
                                                                                id="socSecNum"
                                                                                type="text"
                                                                                pInputText
                                                                                /><label for="socSecNum">Soc Sec Number</label
                                                                                >@for (validation of validationMessages.socSecNum; track validation) {
                                                                                <span
                                                                                  >@if (form1.get('socSecNum').hasError(validation.type) && (form1.get('socSecNum').dirty || form1.get('socSecNum').touched)) {
                                                                                  <small class="p-invalid"
                                                                                    >{{validation.message}}
                                                                                  </small>
                                                                                  }</span
                                                                                  >
                                                                                  }</span
                                                                                  >
                                                                                </div>
                                                                                <div class="col-lg-12">
                                                                                  <span class="p-float-label w-100 mb-3">
                                                                                    <textarea formControlName="emergencyContact" id="emergencyContact" [rows]="2" pInputTextarea></textarea>
                                                                                    <label for="emergencyContact">Emergency Contact</label>
                                                                                    @for (validation of validationMessages.emergencyContact; track validation) {
                                                                                      <span>
                                                                                        @if (form1.get('emergencyContact').hasError(validation.type) && (form1.get('emergencyContact').dirty || form1.get('emergencyContact').touched)) {
                                                                                          <small class="p-invalid"
                                                                                            >{{validation.message}}
                                                                                          </small>
                                                                                        }
                                                                                      </span>
                                                                                    }
                                                                                  </span>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                            <hr />
                                                                            <div class="row m-0">
                                                                              <div class="col-lg-12">
                                                                                <div class="btn-group">
                                                                                  <div class="button-group">
                                                                                    @if (employeeProfileId) {
                                                                                      <button pButton class="btn-delete p-button-outlined p-button-danger"
                                                                                      (click)="onFormDelete()">Delete</button>
                                                                                    }
                                                                                  </div>

                                                                                  <div class="button-group">
                                                                                    <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                                                                                    @if (!employeeProfileId) {
                                                                                      <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
                                                                                    }

                                                                                    @if (employeeProfileId) {
                                                                                      <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
                                                                                    }
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
